import app from 'flarum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import PreferredTagsModal from './PreferredTagsModal';
import skipTags from '../actions/skipTags';

export default class NewTagsModal extends Modal {

    static isDismissible = false;
    storeTags;
    childTags;
    parentTags;
    newTags;
    firstTimeSelectingPreferences;

    oninit(vnode) {
        super.oninit(vnode);

        if(!app.session.user) {
            return;
        }

        this.storeTags = app.store.all('tags').filter(t => t.position() != null);

        this.childTags = this.storeTags.filter(t => t.data.attributes.isChild);
        this.parentTags = this.storeTags.filter(t => !t.data.attributes.isChild);

        this.newTags = this.storeTags.filter(t => t.isPreferred() === null && !t.data.attributes.isChild);
        this.firstTimeSelectingPreferences = this.storeTags.filter(t => t.isPreferred() != null ).length === 0;
    }

    className() {
        return 'NewTagsModal';
    }

    title() {
        return this.firstTimeSelectingPreferences
          ? app.translator.trans('preferred-tags.forum.new-tags-modal.first-time-title')
          : app.translator.trans('preferred-tags.forum.new-tags-modal.title');
    }

    content() {
        const newTagsList = [];
        this.newTags.forEach( tag => {
            newTagsList.push(
                m('li', tag.name())
            );
        });

        const gotoButtonClassName = `Button Button--primary NewTagsModal-footer-button`;

        const skipButtonClassName = `Button Button-secondary NewTagsModal-footer-button`;

        // create the components to use for the modal
        const skipButton = Button.component({
            loading: this.loading,
            className: skipButtonClassName,
            onclick: () => {
                this.skipAllTags();
            }
        }, app.translator.trans('preferred-tags.forum.skip'));

        const gotoButton = Button.component({
            loading: this.loading,
            className: gotoButtonClassName,
            onclick: () => {
                app.modal.show(PreferredTagsModal, {});
            }

        }, app.translator.trans('preferred-tags.forum.new-tags-modal.goto-preferred-btn'));

        return [
            m('.Modal-body.NewTagsModal', [
                this.firstTimeSelectingPreferences ? null
                    : m('p.NewTagsAvailableDescription', app.translator.trans('preferred-tags.forum.new-tags-modal.description')),
                this.firstTimeSelectingPreferences ? null
                    : m('ul.NewTagsList', newTagsList),
                m('p.NewTagsAvailableDescription', this.firstTimeSelectingPreferences ?
                    app.translator.trans('preferred-tags.forum.new-tags-modal.first-time-additional-description')
                    : app.translator.trans('preferred-tags.forum.new-tags-modal.additional-description'))
            ]),
            m('.Modal-body.NewTagsModal-footer', [
                skipButton,
                m('br'),
                gotoButton
            ])
        ];
    }

    onsubmit(event) {
        event.preventDefault();
    }

    skipAllTags() {
        this.loading = true;
        skipTags(this.firstTimeSelectingPreferences, this.newTags).then(() => {
            app.modal.close();
            app.alerts.show({
                type: 'success'
            }, app.translator.trans('preferred-tags.forum.saved'));
        }).finally(() => {
            this.loading = false;
            setTimeout(() => {
                m.redraw();
            }, 100); // timeout is necessary for mithrill to have time to settle the store update before redrawing the ui
        });
    }
}
